var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Controller } from "stimulus";
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.connect = function () {
        console.log("[connect] Modal");
        this._isOpen = false;
        this._loopSpeed = 200;
        this._YTPlayer = null;
        this.bodyElement = document.getElementsByTagName("body")[0];
    };
    default_1.prototype.disconnect = function () {
        console.log("[disconnect] Modal");
    };
    default_1.prototype.open = function (e) {
        console.log("modal.open");
        var $target = e.target;
        var _self = this;
        setTimeout(function () {
            function loop() {
                if ($target.tagName.toLowerCase() !== "a") {
                    // 処理
                    $target = $target.parentNode;
                    loop();
                }
                else {
                    var _target_1 = $target.getAttribute("data-target");
                    _self.bodyTargets.forEach(function (elm, index) {
                        if (elm.getAttribute("id") === "js-modal-target" + _target_1) {
                            elm.classList.add("is-open");
                            var videoElm = elm.querySelector("[data-videoid]");
                            if (videoElm) {
                                var id = videoElm.getAttribute("id");
                                var videoId = videoElm.getAttribute("data-videoid");
                                var _YTPlayer = require("yt-player");
                                _self._YTPlayer = new _YTPlayer("#" + id);
                                _self._YTPlayer.load(videoId);
                                _self._YTPlayer.setVolume(100);
                            }
                            _self._isOpen = true;
                            _self.bodyElement.classList.add("theme-iv-bg");
                            elm.scrollTo(0, 0);
                        }
                    });
                }
            }
            loop();
        }, this._loopSpeed);
    };
    default_1.prototype.close = function (e) {
        console.log("modal.close");
        var _self = this;
        var $target = e.target;
        if ($target.getAttribute("data-action") === "click->modal#close") {
            setTimeout(function () {
                function loop() {
                    if ($target.tagName) {
                        if (!$target.classList.contains("is-open")) {
                            // 処理
                            $target = $target.parentNode;
                            loop();
                        }
                        else {
                            if (_self._YTPlayer) {
                                _self._YTPlayer.stop();
                                _self._YTPlayer.destroy();
                                _self._YTPlayer = null;
                            }
                            $target.classList.remove("is-open");
                            _self.bodyElement.classList.remove("theme-iv-bg");
                            _self._isOpen = false;
                        }
                    }
                }
                loop();
            }, this._loopSpeed);
        }
    };
    default_1.targets = ["body", "close"];
    return default_1;
}(Controller));
export default default_1;
